import * as React from 'react';
import { withTranslation } from '@i18n';
import { useBreakpoint } from '@hooks';
import { Carousel } from '@components/index';

import { StyledCover, StyledTopImageWrapper, StyledCarouselChild } from './styles';
import ImageCarousel from '../../../../../components/PreviewCarousel/index';

const ImagePreviewComponent = ({ packageData, relationshipData }) => {
  const [activeImage, setActiveImage] = React.useState(
    packageData?.data?.attributes?.cover_image_url
  );
  const isMobile = useBreakpoint('mobile', 'tablet');
  const ImagesData = [
    { id: 'coverimageuni1235', url: packageData?.data?.attributes?.cover_image_url },
    ...relationshipData?.treatment_images.data.map(image => ({
      id: image.id,
      url: image.attributes.file.url
    }))
  ] || [];
  return (
    <StyledCover>
      {isMobile ? (
        <Carousel selectedItem={0} centerMode={false} showArrows={false} bottomArrows>
          {ImagesData.map(image => (
            <StyledCarouselChild key={image.id}>
              <img src={image.url} alt="carousel-child" />
            </StyledCarouselChild>
          ))}
        </Carousel>
      ) : (
        <>
          <StyledTopImageWrapper>
            <img src={activeImage} alt="" />
          </StyledTopImageWrapper>
          {relationshipData?.treatment_images.data && (
            <ImageCarousel onScreenCount={4} images={ImagesData} setActiveImage={setActiveImage} />
          )}
        </>
      )}
    </StyledCover>
  );
};

export default withTranslation('ProfilePackages')(ImagePreviewComponent);
